import { Button, Stack, Text } from '@mantine/core';

import { useDryRunUserDataDeletion } from '../api';

type DryRunSectionProps = {
  chatIds: string[];
  file: File | null;
};

export const DryRunSection = ({ chatIds, file }: DryRunSectionProps) => {
  const dryRunUserDataDeletion = useDryRunUserDataDeletion({ chatIds });

  const handleDryRun = () => {
    if (chatIds.length === 0) {
      return;
    }

    dryRunUserDataDeletion.refetch();
  };

  return (
    <Stack>
      <Button variant="outline" disabled={!file} color="blue" onClick={handleDryRun}>
        Dry-run
      </Button>
      {dryRunUserDataDeletion.data && (
        <Stack py="lg">
          <Text>Found Dialogs Count: {dryRunUserDataDeletion.data.dialogsCount}</Text>
          <Text>Found Messages Count: {dryRunUserDataDeletion.data.messagesCount}</Text>
          <Text>
            Found Total:{' '}
            {dryRunUserDataDeletion.data.dialogsCount + dryRunUserDataDeletion.data.messagesCount}
          </Text>
        </Stack>
      )}
    </Stack>
  );
};
